import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ICardProfileBody } from '@models/card.model';
import { UtilitiesService } from '@services/utilities.service';
import { BaseComponent } from '@shared/base/base.component';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BehaviorSubject } from 'rxjs';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { EnumRole } from '@models/role.model';
import { DistributorStatusEnumString } from '@config/enum/distributor.enum';

@Component({
  selector: 'app-card-profile-header',
  templateUrl: './card-profile-header.component.html',
  styleUrls: ['./card-profile-header.component.scss'],
})
export class CardProfileHeaderComponent extends BaseComponent implements OnInit {
  @Input() name: string;
  @Input() role: string;
  @Input() details: BehaviorSubject<string> = new BehaviorSubject<string>('');
  @Input() labelList: ICardProfileBody[];
  @Input() status: { string: string | undefined; value: string | undefined } | undefined;
  @Input() isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  @Input() noteViewInfo = '';
  @Input() badge = '';
  // @Input() isRetailer = false;

  @ViewChild('modalDetail') private modalDetailComponent: ModalComponent;
  @ViewChild('modalWarehouse') private modalWarehouseComponent: ModalComponent;

  enumRole = EnumRole;
  STRING_CONSTANTS = STRING_CONSTANTS;
  modalConfig: ModalConfig = {
    modalTitle: 'Cakupan Area',
    closeButtonLabel: 'Close',
    showFooter: false,
    showHeader: false,
  };
  modalWarehouseConfig: ModalConfig = {
    modalTitle: 'Cakupan Gudang',
    closeButtonLabel: 'Close',
    showFooter: false,
    showHeader: false,
  };
  constructor(public utilities: UtilitiesService) {
    super();
  }

  ngOnInit(): void {}

  handleDetail() {
    if (this.role === this.enumRole.ADMIN_GUDANG) {
      this.modalWarehouseComponent.open().then();
    } else {
      this.modalDetailComponent.open().then();
    }
  }

  getStatusString(status: string | undefined) {
    if (!status) return '-';
    return this.utilities.mapKeyToString(DistributorStatusEnumString, status);
  }
}
